import Component from './order'

export default Component